import React from "react";
import SignInTemplate from "../../../layout/sign-in-template/SignInTemplate";
import Image from "../../../common/image/Image";
import MarketLogo from "../../../../assets/images/logo.png";
import {
	Section,
	PolicyContainer,
	PolicyTitle,
	PolicySubtitle,
	PolicyText,
	PolicyList,
	DividerLine,
	DateText,
} from "./styles";

export default function TermsAndPolicy() {
	return (
		<SignInTemplate>
			<SignInTemplate.Main>
				<SignInTemplate.Top>
					<SignInTemplate.Title>
						Términos de servicio y políticas de privacidad
					</SignInTemplate.Title>
				</SignInTemplate.Top>

				<SignInTemplate.Body>
					<Section>
						<SignInTemplate.Logo>
							<Image
								src={MarketLogo}
								alt="Logo FarmaTransfer"
								height="45px"
								width="220px"
							/>
						</SignInTemplate.Logo>

						<PolicyContainer>
							<PolicyTitle>Política de Privacidad</PolicyTitle>
							<DateText>Última actualización: 12 de diciembre de 2025</DateText>

							<PolicyText>
								Esta Política de Privacidad describe cómo CheckPOS SRL (“la
								Empresa”, “nosotros”) recopila, utiliza y protege los datos
								personales cuando los usuarios interactúan con nuestro Agente de
								Ventas basado en Inteligencia Artificial, disponible a través de
								canales de mensajería como WhatsApp, web u otros medios
								digitales.
							</PolicyText>

							<PolicySubtitle>1. Datos recopilados</PolicySubtitle>
							<PolicyList>
								<li>Nombre y apellido</li>
								<li>Número de teléfono</li>
								<li>Dirección de correo electrónico</li>
								<li>Mensajes enviados por el usuario</li>
								<li>
									Información comercial relacionada con pedidos, consultas o
									cotizaciones
								</li>
								<li>Datos técnicos (fecha, hora, canal de contacto)</li>
							</PolicyList>

							<PolicyText>
								<strong>NO</strong> recopilamos datos sensibles ni financieros.
							</PolicyText>

							<PolicySubtitle>2. Uso de los datos</PolicySubtitle>
							<PolicyList>
								<li>Gestionar conversaciones comerciales automatizadas</li>
								<li>Brindar información sobre productos y servicios</li>
								<li>Procesar pedidos o solicitudes</li>
								<li>Mejorar el desempeño del agente de IA</li>
								<li>Cumplir obligaciones legales y contractuales</li>
							</PolicyList>

							<PolicySubtitle>3. Uso de Inteligencia Artificial</PolicySubtitle>
							<PolicyText>
								Las conversaciones pueden ser procesadas por modelos de IA
								entrenados para responder consultas comerciales. Las respuestas
								no constituyen asesoramiento legal, médico ni financiero.
							</PolicyText>

							<PolicySubtitle>4. Compartición de datos</PolicySubtitle>
							<PolicyList>
								<li>Proveedores tecnológicos (infraestructura cloud, APIs)</li>
								<li>Empresas clientes que utilizan el agente AI</li>
								<li>
									Autoridades legales o judiciales cuando exista requerimiento
								</li>
							</PolicyList>

							<PolicyText>
								<strong>Nunca vendemos datos personales.</strong>
							</PolicyText>

							<PolicySubtitle>5. Seguridad</PolicySubtitle>
							<PolicyText>
								Aplicamos medidas técnicas y organizativas razonables para
								proteger la información contra accesos no autorizados.
							</PolicyText>

							<PolicySubtitle>6. Derechos del usuario</PolicySubtitle>
							<PolicyList>
								<li>Acceso</li>
								<li>Rectificación</li>
								<li>Eliminación</li>
								<li>Limitación del uso de los datos</li>
							</PolicyList>

							<PolicyText>
								Solicitudes vía: <strong>soporte@checkpos.com</strong>
							</PolicyText>

							<DividerLine />

							<PolicyTitle>Condiciones de Servicio</PolicyTitle>
							<DateText>Última actualización: 12 de diciembre de 2025</DateText>

							<PolicySubtitle>1. Descripción del servicio</PolicySubtitle>
							<PolicyText>
								El servicio consiste en un agente automatizado de ventas que
								brinda información, sugiere productos y gestiona pedidos de
								forma asistida por IA.
							</PolicyText>

							<PolicySubtitle>2. Uso permitido</PolicySubtitle>
							<PolicyList>
								<li>Utilizar el servicio con fines lícitos</li>
								<li>No enviar contenido fraudulento, ofensivo o ilegal</li>
								<li>No intentar manipular o explotar el sistema</li>
							</PolicyList>

							<PolicySubtitle>3. Limitaciones</PolicySubtitle>
							<PolicyList>
								<li>El agente AI puede cometer errores</li>
								<li>La información brindada es orientativa</li>
								<li>
									Las decisiones finales de compra son responsabilidad del
									usuario
								</li>
							</PolicyList>

							<PolicySubtitle>4. Disponibilidad</PolicySubtitle>
							<PolicyText>
								El servicio puede ser modificado, suspendido o interrumpido sin
								previo aviso.
							</PolicyText>

							<PolicySubtitle>5. Responsabilidad</PolicySubtitle>
							<PolicyList>
								<li>
									Decisiones comerciales tomadas en base a respuestas del agente
								</li>
								<li>
									Fallas técnicas de terceros (Meta, WhatsApp, proveedores
									cloud)
								</li>
							</PolicyList>

							<DividerLine />

							<PolicyTitle>Eliminación de Datos</PolicyTitle>

							<PolicyText>
								El usuario puede solicitar la eliminación total o parcial de sus
								datos personales enviando un correo a{" "}
								<strong>soporte@checkpos.com</strong>
							</PolicyText>

							<PolicyList>
								<li>Historial de conversaciones</li>
								<li>Datos personales asociados</li>
								<li>Registros comerciales no obligatorios por ley</li>
							</PolicyList>

							<PolicyText>
								La solicitud será procesada dentro de un plazo máximo de 30 días
								corridos. Podremos conservar información mínima si es requerida
								por obligaciones legales.
							</PolicyText>
						</PolicyContainer>
					</Section>
				</SignInTemplate.Body>
			</SignInTemplate.Main>
		</SignInTemplate>
	);
}
